<template>
    <div class="container">
        <b-row v-if="!isLoading">
	<b-container>
		<md-table v-model="listEstados" md-card md-fixed-header @md-selected="f_muestra">
		<md-table-toolbar>
			<h1 class="md-title"><b><i>{{labels.title}}</i></b></h1>
			<md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="f_adicione_estado()">
					<md-icon>add</md-icon>
				</md-button>
			</md-table-toolbar>
			<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
				<md-table-cell :md-label="labels.estado" class="text-center border">{{item.estado}}</md-table-cell>
				<md-table-cell :md-label="labels.descripcion" class="text-left border">{{item.descripcion}}</md-table-cell>
				<md-table-cell :md-label="labels.seguimiento" class="text-left border">{{f_seguimiento(item.seguimiento)}}</md-table-cell>
				<md-table-cell :md-label="labels.observaciones" class="text-left border">{{f_observaciones(item.observaciones)}}</md-table-cell>
				<md-table-cell :md-label="labels.contabiliza" class="text-left border">{{f_contabiliza(item.contabiliza)}}</md-table-cell>
				<md-table-cell :md-label="labels.retomable" class="text-left border">{{f_contabiliza(item.retomable)}}</md-table-cell>
				<md-table-cell :md-label="labels.novedad" class="text-left border">{{f_contabiliza(item.novedad)}}</md-table-cell>
				<md-table-cell :md-label="labels.metrica" class="text-left border">{{item.metrica}}</md-table-cell>
			</md-table-row>
		</md-table>
	</b-container>
	<md-dialog :md-active.sync="adicioneEstado">
		<md-dialog-title class="text-center">
			<h3><b><i>{{labels.title}}</i></b></h3>
		</md-dialog-title>
		<md-dialog-content>
			<md-table>
				<md-table-row>
					<md-table-cell><h4>Estado</h4></md-table-cell>
					<md-table-cell>
						<md-input v-model="form.estado" @input="f_verifique_elimina()"></md-input>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell><h4>Descripcion</h4></md-table-cell>
					<md-table-cell>
						<md-input v-model="form.descripcion" @input="f_verifique_elimina()"></md-input>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell><h4>Seguimiento</h4></md-table-cell>
					<md-table-cell>
						<select v-model="form.seguimiento" class="form-control" @click="f_verifique_elimina()">
						<option :value="0">NO</option>
						<option :value="1">SI</option>
						</select>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell><h4>Observacion</h4></md-table-cell>
					<md-table-cell>
						<select v-model="form.observaciones" class="form-control" @click="f_verifique_elimina()">
						<option :value="0">NO</option>
						<option :value="1">SI</option>
						</select>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell><h4>Contabiliza</h4></md-table-cell>
					<md-table-cell>
						<select v-model="form.contabiliza" class="form-control" @click="f_verifique_elimina()">
						<option :value="0">NO</option>
						<option :value="1">SI</option>
						</select>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell><h4>Retomable</h4></md-table-cell>
					<md-table-cell>
						<select v-model="form.retomable" class="form-control" @click="f_verifique_elimina()">
						<option :value="0">NO</option>
						<option :value="1">SI</option>
						</select>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell><h4>Novedad</h4></md-table-cell>
					<md-table-cell>
						<select v-model="form.novedad" class="form-control" @click="f_verifique_elimina()">
						<option :value="0">NO</option>
						<option :value="1">SI</option>
						</select>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell><h4>Titulo Metrica</h4></md-table-cell>
					<md-table-cell>
						<md-input v-model="form.metrica" @input="f_verifique_elimina()" maxlength="10" size="10" ></md-input>
					</md-table-cell>
				</md-table-row>
			</md-table>
			<md-dialog-actions>
				<md-button v-if="fgl_elimina" class="md-accent" @click="f_eliminaEstado()">Eliminar</md-button>
				<md-button v-if="fgl_actualiza" class="md-accent" @click="f_grabaEstado()">Grabar</md-button>
				<md-button class="md-accent" @click="adicioneEstado=false">Cerrar</md-button>
			</md-dialog-actions>
		</md-dialog-content>
		
		<md-dialog-content v-if="fgl_ver_transicion">

			<md-table >
			<md-table-toolbar>
				<h1 class="md-title text-center"><b><i>TRANSICIONES</i></b></h1>
				<select multiple v-model="estados" class="form-control">
					<option v-for="estado in listEstadosTransicion" :value="estado.estado" :key="estado.id">{{estado.estado}}-{{estado.descripcion}}</option>
				</select>
			</md-table-toolbar>
			</md-table>
		</md-dialog-content>
		
	</md-dialog>
        </b-row>
    </div>
</template>
<script>
import Estado from "@/services/Estados"

export default {
    name:'Estados',
    data: () => ({
        isLoading: false,
	fgl_elimina: true,
	fgl_ver_transicion: false,
	fgl_actualiza: true,
        listEstados : [],
        listTransiciones : [],
        listEstadosTransicion : [],
	form : {
		id: '',
		estado: '',
		descripcion:'',
		seguimiento:'',
		observaciones:'',
		contabiliza:'',
		retomable:'',
		novedad:'',
		idUser:'',
		estados:[],
	},
	formelimina : {
		id: '',
		estado: '',
		descripcion:'',
		seguimiento:'',
		observaciones:'',
		contabiliza:'',
		retomable:'',
		novedad:'',
		metrica:'',
		idUser:'',
		estados:[],
	},
	adicioneEstado: false,
	estados : [],
	descripcion : '',
	seguimiento : '',

    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : "Estados",
                    estado : "Estado",
                    descripcion : "Descripcion",
                    transicion : "Transicion",
                    seguimiento : "Seguimiento",
                    observaciones : "Observaciones",
                    contabiliza : "Contabiliza",
                    retomable : "Retomable",
                    novedad : "Novedad",
                    metrica : "Titulo Metrica",
                }
            }else{
                return {
                    title : "Reazon",
                    estado : "Reason",
                    descripcion : "Description",
                    seguimiento : "Tracing",
                    transicion : "Transition",
                    observaciones : "Observations",
                    contabiliza : "Account",
                    retomable : "Returnable",
                    novedad : "Release",
                    metrica : "Metric Title",
                }
            }
        }
    },
    mounted(){
        Estado.leaEstados()
        .then((res) => {
            this.listEstados = res.data.listEstados
        })
        .catch((err) => {
            console.log(err)
        })
    },
    methods:{
	f_seguimiento(seguimiento) {
		if	(seguimiento == 0) {
			return "NO"
		}
		if	(seguimiento == 1) {
			return "SI"
		}
	},
	f_observaciones(observaciones) {
		if	(observaciones == 0) {
			return "NO"
		}
		if	(observaciones == 1) {
			return "SI"
		}
	},
	f_contabiliza(contabiliza) {
		if	(contabiliza == 0) {
			return "NO"
		}
		if	(contabiliza == 1) {
			return "SI"
		}
	},
	f_adicione_estado() {
		this.form.id=-1
		this.form.estado=''
		this.form.descripcion=''
		this.form.seguimiento=''
		this.form.observaciones=''
		this.form.contabiliza=''
		this.form.retomable=''
		this.form.novedad=''
		this.adicioneEstado=true
		this.fgl_elimina = false
		this.fgl_actualiza = true
	},
	f_muestra(r_estado) {
		this.form.estado = r_estado.estado
		this.form.descripcion = r_estado.descripcion
		this.form.seguimiento = r_estado.seguimiento
		this.form.observaciones = r_estado.observaciones
		this.form.contabiliza = r_estado.contabiliza
		this.form.retomable = r_estado.retomable
		this.form.novedad = r_estado.novedad
		this.form.metrica = r_estado.metrica
		this.form.id = r_estado.id
		this.adicioneEstado=true
		const v_estado = this.form.estado
		const v_descripcion = this.form.descripcion
		const v_seguimiento = this.form.seguimiento
		const v_observaciones = this.form.observaciones
		const v_contabiliza = this.form.contabiliza
		const v_retomable = this.form.retomable
		const v_novedad = this.form.novedad
		const v_metrica = this.form.metrica
		const v_estados = this.form.estados
		this.formelimina.estado = v_estado
		this.formelimina.descripcion = v_descripcion
		this.formelimina.seguimiento = v_seguimiento
		this.formelimina.observaciones = v_observaciones
		this.formelimina.contabiliza = v_contabiliza
		this.formelimina.retomable = v_retomable
		this.formelimina.novedad = v_novedad
		this.formelimina.metrica = v_metrica
		this.formelimina.estados = v_estados
		this.fgl_elimina = true
		this.fgl_actualiza = true
		if	(this.form.seguimiento == 1) {
			this.fgl_ver_transicion=true
			this.listEstadosTransicion=this.listEstados.filter((estado) => estado.estado != this.form.estado)
		} else {
			this.fgl_ver_transicion=false
			this.listEstadosTransicion=[]
		}
		Estado.leaEstadoTransiciones(this.form.estado)
		.then((res) => {
			this.listTransiciones =  res.data.listTransiciones
			this.estados=[]
			this.listTransiciones.forEach((transicion) => {
				this.estados.push(transicion.transicion)
			})
		})
		.catch((error) => {
			console.log(error)
			this.$toast.error("Problema al leer transiciones del estado")
		})
			
	},
	f_grabaEstado() {
		
		if	(this.form.estado == '') {
			this.$toast.error("Estado no puede estar vacia")
			return
		}
		if	(this.form.descripcion == '') {
			this.$toast.error("Descripcion no puede estar vacia")
			return
		}
		if	(this.form.estado == '') {
			this.$toast.error("Estado no puede estar vacio")
			return
		}
		const v_estado = this.listEstados.find((r_estado) => r_estado.estado == this.form.estado)
		this.form.idUser = this.$store.state.userId
		if	(this.form.seguimiento == 0) {
			this.estados = []
		}
		this.form.estados = this.estados
		if	(v_estado === undefined) {
			Estado.grabaEstado(this.form)
			.then((res) => {
				if	(res.status == 200){
					this.$toast.success("Informacion Grabada correctamente")
					setTimeout(() => {
						Estado.leaEstados()
						.then((res) => {
							this.listEstados= res.data.listEstados
						})
						.catch((err) => {
							console.log(err)
						})
					},1000)
				} else {
					this.$toast.error(res.data.message+" al grabar estados")
				}
			})
			.catch((err) => {
				console.log(err)
			})
		} else {
			if	(this.form.id !== -1) {
				Estado.actualizaEstado(this.form)
				.then((res) => {
					if	(res.status == 200){
						this.$toast.success("Informacion Grabada correctamente")
						setTimeout(() => {
							Estado.leaEstados()
							.then((res) => {
								this.listEstados= res.data.listEstados
							})
							.catch((err) => {
								console.log(err)
							})
						},1000)
					} else {
						this.$toast.error(res.data.message+" al grabar estados")
					}
				})
				.catch((err) => {
					console.log(err)
				})
			} else {
				this.$toast.error("Estado ya definido")
			}
		}
		this.adicioneEstado = false
		Estado.leaEstados()
		.then((res) => {
			this.listEstados = res.data.listEstados
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_verifique_elimina() {
		if	(this.formelimina.estado != this.form.estado ||
			this.formelimina.descripcion != this.form.descripcion ||
			this.formelimina.seguimiento != this.form.seguimiento ||
			this.formelimina.observaciones != this.form.observaciones ||
			this.formelimina.contabiliza != this.form.contabiliza ||
			this.formelimina.retomable != this.form.retomable ||
			this.formelimina.metrica != this.form.metrica ||
			this.formelimina.novedad != this.form.novedad) {
			this.fgl_elimina=false
		} else {
			this.fgl_elimina=true
		}
		if	(this.form.seguimiento == 1) {
			this.fgl_ver_transicion = true
			this.listEstadosTransicion=this.listEstados.filter((estado) => estado.estado != this.form.estado)
		} else {
			this.fgl_ver_transicion = false
			this.listEstadosTransicion=[]
			this.estados=[]
		}
		if	(this.formelimina.estado != this.form.estado &&
			this.form.id !== -1 ) {
			this.fgl_actualiza=false
			this.fgl_ver_transicion = false
		} else {
			this.fgl_actualiza=true
		}
	},
	f_borraEstado() {
		Estado.borraEstado(this.form.id)
		.then((res) => {
			if	(res.status == 200){
				this.$toast.success("Informacion Borrada correctamente")
				setTimeout(() => {
					Estado.leaEstados()
					.then((res) => {
						this.listEstados= res.data.listEstados
					})
					.catch((err) => {
						console.log(err)
					})
				},1000)
			} else {
				this.$toast.error(res.data.message+" al borrar estados")
			}
		})
		.catch((err) => {
			console.log(err)
			this.$toast.error("Problema al borrar estados")
		})
		this.adicioneEstado = false
	},
    }
}
</script>

<style>

</style>
